(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sv-video-hero]').forEach((hero) => {
    if (hero.dataset.videoReady === 'true') return;
    hero.dataset.videoReady = 'true';

    const video = hero.querySelector('.sneak-vet-video');
    if (!video || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let started = false;
    const startVideo = () => {
      if (started) return;
      started = true;
      video.load();
      const playback = video.play();
      if (playback) playback.catch(() => {});
    };

    video.addEventListener('playing', () => hero.classList.add('is-playing'), { once: true });

    const scheduleVideo = () => {
      const intentEvents = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
      const startOnIntent = () => {
        intentEvents.forEach((eventName) => window.removeEventListener(eventName, startOnIntent));
        startVideo();
      };

      intentEvents.forEach((eventName) => {
        window.addEventListener(eventName, startOnIntent, { once: true, passive: true });
      });

      window.setTimeout(startOnIntent, 10000);
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        if (document.readyState === 'complete') scheduleVideo();
        else window.addEventListener('load', scheduleVideo, { once: true });
      }, { rootMargin: '100px' });
      observer.observe(hero);
    } else if (document.readyState === 'complete') {
      scheduleVideo();
    } else {
      window.addEventListener('load', scheduleVideo, { once: true });
    }
  });

  document.querySelectorAll('video[data-autoplay]').forEach((video) => {
    if (video.dataset.deferredVideoReady === 'true') return;
    video.dataset.deferredVideoReady = 'true';
    video.preload = 'none';

    const playVideo = () => {
      video.load();
      const playback = video.play();
      if (playback) playback.catch(() => {});
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        playVideo();
      }, { rootMargin: '300px' });
      observer.observe(video);
    } else {
      playVideo();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-cleaning-steps"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const observers = new WeakMap();
    const init = (root) => {
      root.querySelectorAll('[data-sv-guide]').forEach((guide) => {
        if (guide.dataset.guideReady === 'true') return;
        guide.dataset.guideReady = 'true';
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.animate(
              [{ opacity: 0.65, transform: 'translateY(14px)' }, { opacity: 1, transform: 'translateY(0)' }],
              { duration: 480, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)' }
            );
            entry.target.dataset.stepRevealed = 'true';
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.15 });
        guide.querySelectorAll('.sv-guide__step').forEach((step) => observer.observe(step));
        observers.set(guide, observer);
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-sv-guide]').forEach((guide) => observers.get(guide)?.disconnect());
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
